import { createContext } from "react";

import type { AuthenticationStore } from "./AuthenticationStore";
import { getAuthenticationStore } from "./AuthenticationStore.singleton";

export const AuthenticationStoreContext = createContext<AuthenticationStore>(getAuthenticationStore());
